/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/approve_reports/controllers/approveReportsController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 12:11:19 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Mon Dec 10 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import templatePop from '../views/select_regen.html';
class ReportCardClassTeacher {
    constructor($scope, $rootScope, authService, localStorageService, $state, setAndSelectStudentRc, $mdDialog,MARK_ENTRY_SAVE_CONSTANTS) {
      'ngInject';
      let self = this
      let academicSub = undefined;
      let cTReport = undefined;
        $scope.view_only = true
        $rootScope.title = "Class Teacher View"
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
            if (!$rootScope.isLoggedIn) {
              $state.go("login", {}, { reload: true })
            }
            pushLog();
        }
        // if(menuHeaderService && menuHeaderService.authMenu){
        //   $scope.view_only = true
        // }
        // $rootScope.Title("Class Teacher View")
        // self.noAction = false
        let authoring = localStorageService.get('authoringData')
        let subjectDataRegister = localStorageService.get('subjectDataRegister')
        let from_authoring = localStorageService.get('from_authoring')
        let studentRcData = localStorageService.get('studentRcData')
        // Session.clear('subjectDataRc')
        // $scope.loading = true
        let settingsDocs = []
        let school_id = localStorageService.get('school_id')
        let activeAcd = localStorageService.get('activeAcdYear')
        activeAcd = localStorageService.get('academic_year')
        let school_years = localStorageService.get('school_years')
        let school_yearsAlt = localStorageService.get('school_acdy')
        let userId = localStorageService.get('school_id')
        $scope.filterObj = {}
        let thisSchoolId = school_id
        let filterThru = localStorageService.get('can_filter')
        if(filterThru == "true"){
            filterThru = true
        }else{
            filterThru = undefined
        }
        let subjectDataRc = localStorageService.get('subjectDataRc')
        function setRcBelow(firstSubject, generatedData){
          
          self.generatedData = _.filter(generatedData, function(one){

            return one.academic_details.subject_id == firstSubject
          })
        }        

        this.$onDestroy = () => {
          if (academicSub)
            academicSub.stop()
          if (cTReport)
            cTReport.stop()
      }

        // initLoad(authoring, activeAcd)
        function setData(result, authoring, school_yearsArray){

          self.subjects = result.subjects
          let generatedData = result.subjectRcs
          self.allGeneratedData = result.subjectRcs
          let firstSubject = undefined
          let authSubEx = 0
          if(authoring.subject_id || !subjectDataRc){
            _.each(self.subjects, function(subjectObj){
                
                if(subjectObj._id == authoring.subject_id){
                    authSubEx++
                    subjectObj.toBeHighLighted = true
                }else{
                    subjectObj.toBeHighLighted = false
                }
            })
            if(authSubEx > 0){
              firstSubject = authoring.subject_id
            }else{
              if(result.subjects && result.subjects.length){
                firstSubject = result.subjects[0]._id
                result.subjects[0].toBeHighLighted = true
              }
            }
          }else if(subjectDataRc && subjectDataRc.subjectId){//not subjects endoresed
            _.each(self.subjects, function(subjectObj){
                let sEx = 0
                if(subjectObj._id == subjectDataRc.subjectId){
                    
                    subjectObj.toBeHighLighted = true
                }else{
                    subjectObj.toBeHighLighted = false
                }
            })
            firstSubject = subjectDataRc.subjectId
          }else{
            if(result.subjects && result.subjects.length){
              firstSubject = result.subjects[0]._id
              result.subjects[0].toBeHighLighted = true
            }
          }
          $scope.loading = false
          setscYears(school_yearsArray)
          setRcBelow(firstSubject, generatedData)

        }
        function getYearThenConditions(){
          let cond = undefined
          if(localStorageService.get('academicYearRc')){
            self.selected_year = localStorageService.get('academicYearRc')
          }else{
            self.selected_year = activeAcd
          }
          if(!self.selected_year){
            self.selected_year = "2018-2019"
          }
          if(subjectDataRegister){
            cond = subjectDataRegister
          }else{
            cond = authoring
          }
          initLoad(cond, self.selected_year)
          setNoAction(self.selected_year)
        }
        getYearThenConditions()
        
        

        function initLoad(authoring, selectedYear){
          let loadObj = {
              authoring : authoring,
              activeAcd : selectedYear,
              school_id : school_id
          }
          authService.callAPI("/v0/reportcards/classteacher/list", "POST", 
            {args : loadObj}, function (response) {
              console.log(response.result.data.details.response)
              self.userList = response.result.data.details.response.users
              setData(response.result.data.details.response.docs, authoring, response.result.data.details.response.school_years)
              _.defer(function() { $scope.$apply(); });
          })
        }
        $scope.goToSubjectRcs = (subject_id, subjectname) => {
           self.generatedData = _.filter(self.allGeneratedData, function(one){
              return one.academic_details.subject_id == subject_id
           })
           _.each(self.subjects, function(subject){
              if(subject._id == subject_id){
                subject.toBeHighLighted = true
              }else{
                subject.toBeHighLighted = false
              }
           })
           localStorageService.set({
               subjectDataRc: {
                  subjectId : subject_id,
                  subjectName : subjectname
               }
           })
           let obj = {
                 session_id: authoring.session_id,
                 curriculum_id: authoring.curriculum_id,
                 class_id: authoring.class_id,
                 batch_id: authoring.batch_id,
                 subject_id: authoring.subject_id,
                 school_id: authoring.school_id,
                 year_selected : self.selected_year
            }
            localStorageService.set({
                 subjectDataRegister: obj
            })
           
        }
        let schoolid = localStorageService.get('school_id')
        let toServer = {
          school_id : schoolid
        }
        authService.callAPI("/v0/reportcards/classteacher/init", "POST", 
            {args : toServer}, function (response) {
              console.log(response)
        })
        function setscYears(response){
          if(!self.scData){
            self.scData = response
          }
        }
        function setNoAction(passedYear){
          console.log(passedYear +'!='+ activeAcd)
          if(passedYear != activeAcd){
            self.noAction = false
          }else{
            self.noAction = true
          }
        }
        $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams) {
        if (fromState.name === "studentListingForReports") {
               $mdDialog.cancel()
            }
        })
        $scope.setSessionFilters = (filterObj) => {
            if(!$scope.filterObj){
               $scope.filterObj = {}
             }
             if($scope.filterObj.curriculum){
               delete $scope.filterObj.curriculum
             }
             if($scope.filterObj.templates){
               delete $scope.filterObj.templates
             }if($scope.filterObj.xclass){
               delete $scope.filterObj.xclass
             }
            Meteor.call('curriculumFiterRc', $scope.filterObj, thisSchoolId, filterThru, activeAcd, function(error, result){
                if(result){
                    self.curriculumArray = []
                    self.curriculumArray = result

                }
                $scope.loading = false
                _.defer(function() { $scope.$apply(); });
            })
        }
        self.getClass = (filterObj) => {
            $scope.filterObj['curriculum'] = filterObj
            
            Meteor.call('classFiterRc', $scope.filterObj, thisSchoolId, filterThru, activeAcd, function(error, result){
                if(result){
                    self.classArray = result
                }
                $scope.loading = false
                _.defer(function() { $scope.$apply(); });
            })
        }
        self.selectBatches = (filterObj) => {
            $scope.filterObj['xclass'] = filterObj
            $scope.filterObj['batch_id'] = undefined
            $scope.filterObj['subject_id'] = undefined
            
            Meteor.call('batchFiterRc',$scope.filterObj, thisSchoolId, filterThru, activeAcd, function(error, result){
                if(result){
                    self.batchArray = result.batchArray
                }
                $scope.loading = false
                _.defer(function() { $scope.$apply(); });
            })
        }
        self.selectSubjects = (filterObj) => {
            $scope.filterObj['batch_id'] = filterObj
            $scope.filterObj['subject_id'] = undefined
            self.subjectArray = undefined
            
            Meteor.call('getSubjectRc', $scope.filterObj,thisSchoolId, filterThru, activeAcd, function(error, result){
                if(result){
                    if(!filterThru){
                        self.subjectArray = result.selection.subjectArray
                    }else{
                        self.subjectArray = result.subjects
                    }
                }else{
                  if(error){

                    toastr.error(error.reason)
                  }
                }
                $scope.loading = false
                _.defer(function() { $scope.$apply(); });
            })
        }
        function getAuthoringData(authoring){
          if(!authoring){
            authoring = {}
          }
          if(!authoring.session_id){
            authoring.session_id = $scope.filterObj.session
          }
          if(!authoring.curriculum_id){
            authoring.curriculum_id = $scope.filterObj.curriculum
          }
          if(!authoring.class_id){
            authoring.class_id = $scope.filterObj.xclass
          }
          if(!authoring.batch_id){
            authoring.batch_id = $scope.filterObj.batch_id
          }
          if(!authoring.subject_id){
            authoring.subject_id = $scope.filterObj.subject_id
          }
          if(!authoring.school_id){
            authoring.school_id = thisSchoolId
          }
          
          return authoring
        }
        function getSettingsName(authoring){
          if(settingsDocs && settingsDocs.length){
            if(!authoring.session && authoring.session_id){
              let res = _.find(settingsDocs, function(oneObj){
                return oneObj._id == authoring.session_id
              })
              if(res){
                authoring.session = res.name
              }
            }
            if(!authoring.curriculum && authoring.curriculum_id){
              let res = _.find(settingsDocs, function(oneObj){
                return oneObj._id == authoring.curriculum_id
              })
              if(res){
                authoring.curriculum = res.name
              }
            }
            if(!authoring.class && authoring.class_id){
              let res = _.find(settingsDocs, function(oneObj){
                return oneObj._id == authoring.class_id
              })
              if(res){
                authoring.class = res.name
              }
            }
            if(!authoring.batch && authoring.batch_id){
              let res = _.find(settingsDocs, function(oneObj){
                return oneObj._id == authoring.batch_id
              })
              if(res){
                authoring.batch = res.name
              }
            }
            if(!authoring.subject && authoring.subject_id){
              let res = _.find(settingsDocs, function(oneObj){
                return oneObj._id == authoring.subject_id
              })
              if(res){
                authoring.subject = res.name
              }
            }
          }
          
          return authoring
        }
        $scope.goToSubjectReport = (subjectId, subjectName, fromSession) => {
            setscYears()
            setNoAction(self.selected_year)
            $scope.loading = true
            // return false
            localStorageService.set({
                 subjectDataRc: {
                    subjectId : subjectId,
                    subjectName : subjectName
                 }
             })
            
            authoring = getAuthoringData(authoring)
            authoring = getSettingsName(authoring)
            let obj = {
                 session_id: authoring.session_id,
                 curriculum_id: authoring.curriculum_id,
                 class_id: authoring.class_id,
                 batch_id: authoring.batch_id,
                 subject_id: authoring.subject_id,
                 school_id: authoring.school_id,
                 year_selected : self.selected_year
            }
            if(authoring.session){
              obj.session = obj.session
            }
            if(authoring.curriculum){
              obj.curriculum = obj.curriculum
            }
            if(authoring.class){
              obj.class = obj.class
            }
            if(authoring.batch){
              obj.batch = obj.batch
            }
            if(authoring.subject){
              obj.subject = obj.subject
            }
            localStorageService.set({
                 subjectDataRegister: obj
             })
            let dontMiss = localStorageService.get("subjectDataRegister")
            if(dontMiss && fromSession){
              if(!authoring.session_id){
                authoring.session_id = dontMiss.session_id
              }
              if(!authoring.curriculum_id){
                authoring.curriculum_id = dontMiss.curriculum_id
              }
              if(!authoring.class_id){
                authoring.class_id = dontMiss.class_id
              }
              if(!authoring.batch_id){
                authoring.batch_id = dontMiss.batch_id
              }
              if(!authoring.batch_id){
                authoring.subject_id = dontMiss.subject_id
              }
            }
            
            Meteor.call('getReportCardForThisSubject', authoring, subjectId, self.selected_year, function(err, res){
                if(res){
                    self.generatedData = res.data
                    if(res.existingDataSubjectIds && !fromSession){
                        _.each(self.subjects, function(subjectObj){
                            if(subjectObj._id == res.existingDataSubjectIds){
                                subjectObj.toBeHighLighted = true
                            }else{
                                subjectObj.toBeHighLighted = false
                            }
                        })
                    }

                }
                if(fromSession && res && res.existingDataSubjectIds){
                    loadPage(true,res.existingDataSubjectIds, self.selected_year)
                }
                $scope.loading = false
                _.defer(function() { $scope.$apply(); });;
            })
        }
        function initialLoad(){
          
          Meteor.call('getSchoolDataYear', thisSchoolId, function(err, scd){
            if(scd){
              self.scData = scd.academic_year
              
              let acdYear = _.find(scd.academic_year, function(oneY){
                  return oneY.status == 'active'
              })
              if(acdYear){
                if(Session.get('academicYearRc')){
                  self.selected_year = localStorageService.get('academicYearRc')
                }else{
                  self.selected_year = acdYear.year
                }
                if(subjectDataRc){
                  console.log('>>>>>>>>>>>')
                  // $scope.goToSubjectReport(subjectDataRc.subjectId, subjectDataRc.subjectName, true)
                }else{
                  console.log('<<<<<<<<<<<<')
                  loadPage(false, null, self.selected_year)

                }
              }
            }
          })
          
        }
        self.searchValuesBasedOnFilter = () => {
          initialLoad()
        }
        
        self.listRcWithSelectedYear = (selected_year) => {
            self.subjects = []
            console.log(self.selected_year)
            self.selected_year = selected_year
            localStorageService.remove('subjectDataRc');
            self.generatedData = []
            $scope.loading = true
            localStorageService.set({
                 academicYearRc: selected_year
             })
             
            initLoad(authoring, selected_year)
            // loadPage(false, null, selected_year)
        }

        function loadPage(fromSession, existingDataSubjectId, selected_year){
            setscYears()
            if(!selected_year){
              selected_year = self.selected_year
            }
            setNoAction(selected_year)
            authoring = getAuthoringData(authoring)
            if(!authoring){
              toastr.error("Please check academic selection!")
              return false
            }
            if(!authoring.session_id){
              toastr.error("Please check academic session!")
              return false
            }
            if(!authoring.curriculum_id){
              toastr.error("Please check academic curriculum!")
              return false
            }
            if(!authoring.class_id){
              toastr.error("Please check academic class!")
              return false
            }
            if(!authoring.batch_id){
              toastr.error("Please check academic batch!")
              return false
            }
            if(!authoring.subject_id){
              toastr.error("Please check academic subject!")
              return false
            }
        }
        self.viewTemplate = (id) => {
            $state.go('viewGeneratedReportData', {
                "dataId": id,
                "isClassTeacher" : true,
                selected_year : self.selected_year,
                is_edit : false
            })
        }

        $scope.goToStudentReports = (user_id, user_name) => {
            localStorageService.set({
                 studentRcData: {
                    user_id : user_id,
                    user_name : user_name
                 }
            })
            localStorageService.set("classTeacherRole",true)
            $state.go('publishedReports', {
                "student_id": user_id,
                fee_status : true
            })
        }

        $scope.regenerateByCt = (card) => {
            let cardId = card.report_console_id
            let reportDataId = card._id
            let academics = card.academic_details
            localStorageService.set({
                 cTregen: {
                     session_id: academics.session_id,
                     curriculum_id: academics.curriculum_id,
                     class_id: academics.class_id,
                     batch_id: academics.batch_id,
                     subject_id: academics.subject_id,
                     school_id: authoring.school_id
                 }
             })
            // console.log(Session.get('cTregen'))
            $state.go('reportCardGenConsole', {
                "cardId": cardId,
                "dataId": reportDataId,
                "re_generate": true,
                "fromCt" : true
            })
        }
         $scope.selectRegen = (card) => {
            // console.log(authoring)
           let cardId = card.report_console_id
            let reportDataId = card._id
            let academics = card.academic_details
            // Session.set({
            //      cTregen: {
            //          session_id: academics.session_id,
            //          curriculum_id: academics.curriculum_id,
            //          class_id: academics.class_id,
            //          batch_id: academics.batch_id,
            //          subject_id: academics.subject_id,
            //          school_id: authoring.school_id
            //      }
            //  })
           let acd = {
             session_id: academics.session_id,
             curriculum_id: academics.curriculum_id,
             class_id: academics.class_id,
             batch_id: academics.batch_id,
             subject_id: academics.subject_id,
             school_id: authoring.school_id
           }
           if(self.userList){
              // console.log(res)
              // var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
              $mdDialog.show({
                  template: templatePop,
                  controller: ['$scope', '$mdDialog', 'list', '$state', 
                  'parentScopeObj' ,'card','authoring','setAndSelectStudentRc','localStorageService', StudentsCtrl],
                  parent: angular.element(document.body),
                  locals: {
                      list: self.userList,
                      parentScopeObj: $scope,
                      card : card,
                      authoring:authoring,
                      setAndSelectStudentRc : setAndSelectStudentRc,
                      localStorageService : localStorageService
                  },
                  clickOutsideToClose: true,
                  fullscreen: true
              })
              .then(function() {

              }, function() {
                  $scope.status = 'You cancelled the dialog.';
              });
          }
          //  Meteor.call('getStudentsThisclass', acd,function(er, res){
          //             // make dialog popup here
          //   if(res){
          //       // console.log(res)
          //       // var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
          //       $mdDialog.show({
          //           templateUrl: templatePop,
          //           controller: ['$scope', '$mdDialog', 'list', '$state', 'parentScopeObj' ,'card','authoring','setAndSelectStudentRc', StudentsCtrl],
          //           parent: angular.element(document.body),
          //           locals: {
          //               list: res,
          //               parentScopeObj: $scope,
          //               card : card,
          //               authoring:authoring,
          //           },
          //           clickOutsideToClose: true,
          //           fullscreen: true
          //       })
          //       .then(function() {

          //       }, function() {
          //           $scope.status = 'You cancelled the dialog.';
          //       });
          //   }
          //   _.defer(function() { $scope.$apply(); });;
          // })
    
        }
        $scope.navigateToDownload = () => {
          $state.go('multipleReportsSelectionCtrl',{})
        }
        function pushLog(){ 
          let userIds = localStorageService.get('user_id');
          let schoolIds = localStorageService.get('school_id');
          authService.callRabbitMQAPI("/v0/rabbitmqpush/"+userIds+"/"+schoolIds+"/studentReportListing", "GET", {},function (response) {
                // console.log(response)
          });
        }
        self.syncReportCard = (card)=>{
          console.log(card);
          if(!card.mark_entry_updated){
            toastr.success('Report Card is already up to date with the latest mark entry')
            return
          }
          mainReportCheck(card)
        }
        function mainReportCheck(card) {
          let st = "Are you sure you want to sync the report card with latest mark entry?"
                let confirm = $mdDialog
                    .confirm()
                    .title(st)
                    .ok("Yes")
                    .cancel("No");
                $mdDialog.show(confirm).then(
                    function () {
              $scope.loading= true
                        let reqObj = {
                session: card.academic_details.session_id,
                curriculum: card.academic_details.curriculum_id,
                class: card.academic_details.class_id,
                batch: card.academic_details.batch_id,
                subject: card.academic_details.subject_id,
                school_id: card.report_card_header.school_id,
                academic_year: card.report_card_header.academic_year,
                report_console_id: card.report_console_id
              }
              authService.callAPI("/v0/reportcards/teacher/main/autogenerate", 'POST', reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                  let reqArr = [];
                  _.each(response.result.data.details, function (data) {
                    reqArr.push({
                      aliace: data.bucket.aliace,
                      db_key: data.bucket.db_key,
                      list: [{
                        activity_name: data.markEntryDetail.exam,
                        activity_id: data.markEntryDetail._id,
                        created_by: userId,
                        type: "activities"
                      }],
                       max_mark: data.bucket.max_mark,
                      // max_mark: 100,
                      name: data.bucket.name,
                      selection: "best"
                    });
                  });
                  let activityCondition = {
                    session_id: card.academic_details.session_id,
                    curriculum_id: card.academic_details.curriculum_id,
                    class_id: card.academic_details.class_id,
                    batch_id: card.academic_details.batch_id,
                    subject_id: card.academic_details.subject_id,
                    school_id: card.report_card_header.school_id,
                  }
                  let reqObj = {
                    args: {
                      cardId: card.report_console_id,
                      report_card_id:card._id,
                      valuesUnderSkills: reqArr,
                      activityCondition: activityCondition,
                      dataId: false,
                      re_generateFlag: false,
                      fromCt: false,
                      select_regen: false,
                      get_students_selected: [],
                      myUserId: userId,
                      report_card_sync:true
                    }
                  }
    
                  authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_REPORT_CARD_GENERATE, 'POST', reqObj, function (response) {
                    try {
                      if (response.error && response.error.error == "Already generated the report!") {
                        toastr.error(response.error.error);
                      } else {
                        let result = response.result.data.details.response;
                        card.mark_entry_updated = false;
                        toastr.success("Report card is updated with latest mark entry")
                        
                      }
                      $scope.loading = false
                      $scope.$apply()
                    } catch (ex) {
                      console.log(ex);
                    }
                  })
                } else if (response.error && response.error.error && response.error.error.message) {
                    $scope.loading = false
                  $mdDialog.show(
                    $mdDialog.alert()
                      .clickOutsideToClose(true)
                      .title('Alert!')
                      .textContent(response.error.error.message)
                      .ariaLabel('Alert Dialog Demo')
                      .ok('OK')
                  );
                 }
              });
                    },
                    function () { }
                );
    
    
            }
    }
}
class StudentsCtrl {
  constructor($scope, $mdDialog, list, $state, parentScopeObj, card, authoring, 
    setAndSelectStudentRc, localStorageService) {
          
          let usersList = []
          let academics = card.academic_details
          console.log(setAndSelectStudentRc)
          _.each(list, function(oneUser){
             if(oneUser.subjects && oneUser.subjects.indexOf(academics.subject_id) !== -1){
              usersList.push(oneUser)
             }
          })
          $scope.items = usersList
           $scope.selected = [];
              $scope.toggle = function (item, list) {
          var idx = list.indexOf(item);
          if (idx > -1) {
            list.splice(idx, 1);
          }
          else {
            list.push(item);
          }
        };

        $scope.exists = function (item, list) {
          return list.indexOf(item) > -1;
        };

        $scope.isIndeterminate = function() {
          return ($scope.selected.length !== 0 &&
              $scope.selected.length !== $scope.items.length);
        };

        $scope.isChecked = function() {
          return $scope.selected.length === $scope.items.length;
        };

        $scope.toggleAll = function() {
          if ($scope.selected.length === $scope.items.length) {
            $scope.selected = [];
          } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
            $scope.selected = $scope.items.slice(0);
          }
        }

        $scope.cancel = () => {
          $mdDialog.hide()
        }
        $scope.confirm = () => {
          let cardId = card.report_console_id
          let reportDataId = card._id
          let academics = card.academic_details
          // localStorageService.set({
          //      cTregen: {
          //          session_id: academics.session_id,
          //          curriculum_id: academics.curriculum_id,
          //          class_id: academics.class_id,
          //          batch_id: academics.batch_id,
          //          subject_id: academics.subject_id,
          //          school_id: authoring.school_id
          //      }
          //  })
           localStorageService.set("cTregen", {
            session_id: academics.session_id,
            curriculum_id: academics.curriculum_id,
            class_id: academics.class_id,
            batch_id: academics.batch_id,
            subject_id: academics.subject_id,
            school_id: authoring.school_id
          })
           
          if(!$scope.selected.length){
              toastr.error("Please select any student!")
              return false
          }
          let set_students_selected = setAndSelectStudentRc.set_students_selected($scope.selected);
          $mdDialog.hide()
          $state.go('reportCardGenConsole', {
              "cardId": cardId,
              "dataId": reportDataId,
              "re_generate": true,
              "fromCt" : true
          })
        }
  }
}
export default ReportCardClassTeacher;



// WEBPACK FOOTER //
// ./src/app/report_cards/class_teacher/controllers/classteacherController.js